<template>
  <artmisads-modal
    :visible.sync="visible"
    title="Create New Adjustment"
    width="600px"
    @cancel="visible = false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :maskClosable="false"
  >
    <div>
      <a-form
        :model="formState"
        name="basic"
        :label-col="{ span: 6 }"
        autocomplete="off"
        ref="formRef"
      >
        <a-form-item
          label="Account"
          name="userEmail"
          :rules="[{ required: true, message: 'Please input Account' }]"
        >
          <a-select
            v-model:value="formState.userEmail"
            show-search
            placeholder="input search text"
            style="width: 100%"
            allowClear
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :options="options"
            @search="onSearch"
            @change="onSelect"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body
              }
            "
          ></a-select>
          <!-- <a-auto-complete
          class="autoComplete"
            v-model:value="formState.userEmail"
            :options="options"
            style="width: 100%;height: 32px;"
            size="large"
            @search="onSearch"
            @select="onSelect"
            allow-clear
            @clear="onResetComplete"
            placeholder="Select Username"
            :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
          >
          </a-auto-complete> -->
        </a-form-item>

        <a-form-item
          label="Marketplace"
          name="marketplace"
          :rules="[{ required: true, message: 'Please select Marketplace' }]"
        >
          <div ref="marketplaceRef">
            <artmisads-select
              style="width: 100%"
              v-model:value="formState.marketplace"
              :getPopupContainer="() => marketplaceRef"
              :options="COUNTRY_BASE_OPTIONS"
              @change="onMarketplaceChange"
            />
          </div>
        </a-form-item>

        <a-form-item
          label="Amazon Seller"
          name="amazonSellerName"
          :rules="[{ required: true, message: 'Please select Amazon Seller' }]"
        >
          <div ref="amazonSellerRef">
            <artmisads-select
              style="width: 100%"
              v-model:value="formState.amazonSellerName"
              :getPopupContainer="() => amazonSellerRef"
              :options="amazonSellerOptions"
              @change="onAmazonSellerChange"
            />
          </div>
        </a-form-item>
        <a-form-item
          label="ASIN"
          name="asin"
          :rules="[{ required: true, message: 'Please input ASIN' }]"
        >
          <artmisads-select
            :disabled="
              !formState.marketplace ||
              !formState.amazonSellerName ||
              !formState.userEmail
            "
            show-search
            @search="fetchUser"
            style="width: 100%"
            v-model:value="formState.asin"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body
              }
            "
            :filter-option="false"
            :options="optionsAsin"
          />
          <!-- <a-select
            v-model:value="formState.asin"
            show-search
            placeholder="input search text"
            style="width: 100%"
            allowClear
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :options="optionsAsin"
            @search="onSearchAsin"
            @change="onSelectAsin"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body
              }
            "
          ></a-select> -->
          <!-- <a-input v-model:value="formState.asin" /> -->
        </a-form-item>
        <a-form-item
          label="Date Range"
          name="dateRange"
          :rules="[{ required: true, message: 'Please select Date Range' }]"
        >
          <div ref="timeRef">
            <a-range-picker
              v-model:value="formState.dateRange"
              style="width: 100%"
              :disabled-date="disTime"
              :disabled="!formState.marketplace"
              :getPopupContainer="() => timeRef"
            />
          </div>
        </a-form-item>
        <a-form-item
          label="Full Price"
          name="fullPrice"
          :rules="[{ required: true, message: 'Please input Full Price' }]"
        >
          <a-input-number
            style="width: 100%"
            v-model:value="formState.fullPrice"
            :min="0"
            :max="1000000"
          />
        </a-form-item>
        <a-form-item
          label="Final Price"
          name="finalPrice"
          :rules="[{ required: true, message: 'Please input Final Price' }]"
        >
          <a-input-number
            style="width: 100%"
            v-model:value="formState.finalPrice"
            :max="Number(formState.fullPrice) - 1"
            :min="0"
          />
        </a-form-item>
        <a-form-item
          label="Deal Type"
          name="dealType"
          :rules="[{ required: true, message: 'Please select Deal Type' }]"
        >
          <div ref="dealTypeRef">
            <artmisads-select
              style="width: 100%"
              v-model:value="formState.dealType"
              :getPopupContainer="() => dealTypeRef"
              :options="dealTypeOptions"
              @change="onDealTypeChange"
            />
          </div>
        </a-form-item>
        <a-form-item
        v-if="formState.dealType === 'Promo Code'"
          label="Promo Code"
          name="promoCode"
          :rules="[{ required: true, message: 'Please input Promo Code' }]"
        >
          <a-input v-model:value="formState.promoCode" />
        </a-form-item>
        <a-form-item
          label="Comment"
          name="comment"
        
        >
          <a-textarea
            rows="{6}"
            style="height: 120px"
            v-model:value="formState.comment"
          />
        </a-form-item>
      </a-form>
    </div>
    <template #footer>
      <div class="footer">
        <artmisads-button isSquare="true" @click="visible = false"
          >Cancel</artmisads-button
        >
        <artmisads-button isSquare="true" type="primary" @click="onSubmit"
          >Submit</artmisads-button
        >
      </div>
    </template>
  </artmisads-modal>
</template>
<script setup>
import { ref, defineExpose, watch, defineEmits, nextTick } from 'vue'
import { COUNTRY_BASE } from '~/contants/common'
import { financeApi } from '~/server/operator/finance'
import { sellerPlacementApi } from '~/server/index'
import { BILLING_TIME_TZ, COUNTRY_SITE_CODE_MAP } from '~/contants/common'
import { debounce } from 'lodash-es';
import moment from 'moment'
import { message } from 'ant-design-vue'
import { max, min } from 'lodash'
const parmas = ref({
  userId: '',
})
const timeRef = ref(null)
const marketplaceRef = ref(null)
const amazonSellerRef = ref(null)
const dealTypeRef = ref(null)
const formRef = ref(null)
const visible = ref(false)
const formState = ref({
  userEmail: '',
  marketplace: '',
  adjustment: '',
  adjustmentAmount: '',
  asin: '',
  dealType: '',
  promoCode: '',
  comment: '',
})
const optionsAsin = ref([])
const emits = defineEmits(['refresh'])
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
})
watch(
  () => formState.value,
  (newVal) => {
    if (newVal.amazonSellerName && newVal.marketplace && newVal.userEmail) {
      // if( formState.value.asin){
      //   formState.value.asin=''
      // }
      getAsin()
    }
  },
  { deep: true }
)
const userInfoArr = ref([])
const options = ref([])
const amazonSellerOptions = ref([])
const dealTypeOptions = ref([
  {
    label: 'Deal',
    value: 'Deal',
  },
  {
    label: 'Clippable Coupon',
    value: 'Clippable Coupon',
  },
  {
    label: 'Promo Code',
    value: 'Promo Code',
  },
])
const getSellerConnections = async () => {
  // const res = await sellerPlacementApi.getSellerConnections(parma)
  // sellerNameOptions.value = res.data.data.map(item => {
  //   return {
  //     label: item.amazonName,
  //     value: item.amazonUserId,
  //   }
  // })
}
const onMarketplaceChange = (value) => {
  formState.value.marketplace = value
  formState.value.amazonSellerName = ''
  formState.value.asin = ''
  getAmazonSeller()
}
const onAmazonSellerChange = (value) => {
  formState.value.asin = ''
}
const disTime = (current) => {

  // 确保current不为null
  if (!current) {
    return false
  }
  if(!formState.value.marketplace){
    return false
  }
  const time = moment().tz(BILLING_TIME_TZ[formState.value.marketplace])
    .format('YYYY-MM-DD')
  const marketplaceYesterday = moment(time).subtract(1, 'day').endOf('day')
  return current && current > marketplaceYesterday
}
const getAmazonSeller = () => {
  const parma = {
    page: 1,
    size: 10000,
    sellerId: parmas.value.userId,
    countryCode: COUNTRY_SITE_CODE_MAP[formState.value.marketplace],
  }
  financeApi.getSellerInfo(parma).then((res) => {
    amazonSellerOptions.value = res.data.map((item) => {
      return {
        label: item.amazonName,
        value: item.amazonName,
      }
    })
  })
}
const onAdjustmentChange = (value) => {
  formState.value.adjustment = value
}
const fetchUser = debounce(value => {
    console.log(value,'value')
    getAsin(value)
})
const onSubmit = async () => {
  await formRef.value.validate().then((res) => {
    const param = {
      sellerId: parmas.value.userId,
      marketplace: formState.value.marketplace,
      amazonSellerName: formState.value.amazonSellerName,
      productId: formState.value.asin,
      type: formState.value.dealType,
      fullPrice: formState.value.fullPrice,
      finalPrice: formState.value.finalPrice,
      promoCode: formState.value.promoCode,
      comment: formState.value.comment,
      beginTime: moment(formState.value.dateRange[0]).valueOf(),
      endTime: moment(formState.value.dateRange[1]).valueOf(),
      beginTimeStr: moment(formState.value.dateRange[0]).format('YYYY/MM/DD'),
      endTimeStr: moment(formState.value.dateRange[1]).format('YYYY/MM/DD'),
    }
    financeApi.addDeal(param).then((res) => {
      if (res.success) {
        message.success('Add Deal Success')
        formRef.value.resetFields()
        visible.value = false
        emits('refresh')
      }
    })
  })
}
const onSearch = (e) => {
  const parma = {
    email: e,
  }
  getUser(parma)
}
const onSelect = (e) => {
  const res = userInfoArr.value.find((v) => v.userId == e)
  formState.value.userEmail = res.email
  parmas.value.userId = res.userId
  formState.value.amazonSellerName = ''
  formState.value.asin = ''
  getAmazonSeller()
}
// const onSearchAsin = (value) => {
//   optionsAsin.value = []
//   getAsin()
// }
const getAsin = async (value) => {

  const parma = {
    sellerId: parmas.value.userId,
    countryCode: COUNTRY_SITE_CODE_MAP[formState.value.marketplace],
    amazonName: formState.value.amazonSellerName,
    keyword: value,
  }
  const res = await financeApi.getAsinInfo(parma)

  optionsAsin.value = res.map((item) => ({
    label: item.asin,
    value: item.id,
  }))

}
const onSelectAsin = (value) => {
  formState.value.asin = value
}
const getUser = async (parma) => {
  const res = await financeApi.getUserInfo(parma)
  let data = res.filter((v) => v.userType === 'seller')
  options.value = data.map((item) => ({
    label: item.email,
    value: item.userId,
  }))
  userInfoArr.value = data
}
const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo)
}
defineExpose({
  show() {
    visible.value = true
    amazonSellerOptions.value = []
    parmas.value.userId = ''
    optionsAsin.value = []
    nextTick(() => {
      formRef.value.resetFields()
    })

  },
})
</script>
<style scoped lang="less">
.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}
</style>
